import { TagChipContent } from './tagChipContent'
import styles from './PostComposer.module.css'

export default function TagChipPicker({ tags = [], selectedTagIds = [], onToggle }) {
  if (tags.length === 0) {
    return <p className={styles.emptyNote}>No tags available</p>
  }

  return (
    <div className={styles.tagChips}>
      {tags.map((tag) => {
        const selected = selectedTagIds.includes(tag.id)
        return (
          <label
            key={tag.id}
            className={`${styles.tagChip} ${selected ? styles.tagActive : ''}`}
          >
            <input
              type="checkbox"
              checked={selected}
              onChange={() => onToggle(tag.id)}
              className={styles.hiddenInput}
            />
            <TagChipContent tag={tag} />
          </label>
        )
      })}
    </div>
  )
}
